module.exports = new __parcel__URL__("khotynenko_x1.00ac7059.webp").toString();